export default __webpack_public_path__ + "static/media/soup-starters.73233234.jpg";